module.exports = __webpack_public_path__ + "img/commit_statement.aa63ea55.jpg";